import Clarity from "@microsoft/clarity";

export class ClarityAnalytics {
  constructor(projectId: string) {
    try {
      if (typeof window !== "undefined") {
        Clarity.init(projectId);
      }
    } catch (e) {
      console.warn("Clarity init failed", e);
    }
  }

  identifyUser(id: string, sessionId?: string, pageId?: string, friendly?: string) {
    try {
      Clarity.identify(id, sessionId, pageId, friendly);
    } catch (e) {
      console.error("Clarity identify error", e);
    }
  }

  setTag(key: string, value: string | string[]) {
    try {
      Clarity.setTag(key, value);
    } catch (e) {
      console.error("Clarity setTag error", e);
    }
  }

  trackEvent(name: string) {
    try {
      Clarity.event(name);
    } catch (e) {
      console.error("Clarity event error", e);
    }
  }

  setCookieConsent(consent: boolean = true) {
    try {
      Clarity.consent(consent);
    } catch (e) {
      console.error("Clarity consent error", e);
    }
  }

  upgradeSession(reason: string) {
    try {
      Clarity.upgrade(reason);
    } catch (e) {
      console.error("Clarity upgrade error", e);
    }
  }
}
